export default "__VITE_ASSET__BqV6d8bz__"